import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import PipelineService from "../../../Services/Pipeline.service";
const makeSearchArgs = {
    loadOptions: (search, options) => 
    // @ts-expect-error - TS2322 - Type 'Promise<Pipeline[] | PipelineLite[]>' is not assignable to type 'Promise<Pipeline[]>'.
    PipelineService.search({
        virtualizedAppName: options.virtualizedAppName,
        createdDateFrom: options.createdDateFrom,
        createdDateTo: options.createdDateTo,
        modifiedDateFrom: options.modifiedDateFrom,
        modifiedDateTo: options.modifiedDateTo,
        pipelineIds: options.pipelineIds,
        canViewRoleIds: options.canViewRoleIds,
        canManageOpportunitiesRoleIds: options.canManageOpportunitiesRoleIds,
        pipelineStatusIds: options.pipelineStatusIds,
        personTypeName: options.personTypeName,
        personTypeIds: options.personTypeIds,
        excludingPipelineIds: options.excludingPipelineIds,
        query: search,
    }).then(({ data }) => {
        return data;
    }),
    label: "name",
    value: "id",
};
export const PipelineSearch = makeSearch(makeSearchArgs);
export const PipelineMultiSearch = makeMultiSearch(makeSearchArgs);
